import { useState } from "react";
import { TableCell } from "../../ui/Table/Table";
import { Checkbox } from "../../ui/Input/Input";

export default function OfferRow({ offer, selected, onToggleSelect }){
    const [isCopied, setIsCopied] = useState(false);

    const {
        display_line,
        team,
        cc,
        language,
        model,
        price,
        cr,
        funnels,
        sources,
        createdAt,
        created
    } = offer;

    const handleCopy = async () => {
        if (typeof navigator !== 'undefined' && navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(display_line);
                if (!isCopied) {
                    setIsCopied(true);
                    setTimeout(() => {
                        setIsCopied(false);
                    }, 1000)
                }
            } catch (err) {
                console.error('Error of copy:', err);
            }
        }
    };

    return (
        <tr>
            <TableCell
                className={'check_cell'}
                cellScroll={false}
                onClick={onToggleSelect}
            >
                <Checkbox checked={selected} onChange={onToggleSelect}/>
            </TableCell>
            <TableCell
                className={`copy_cell ${isCopied ? 'copy_cell_copied' : ''}`}
                cellScroll={false}
                onClick={handleCopy}
            >
                {display_line || '-'}
            </TableCell>
            <TableCell>
                {team || '-'}
            </TableCell>
            <TableCell>
                {cc || '-'}
            </TableCell>
            <TableCell>
                {language || '-'}
            </TableCell>
            <TableCell>
                {model || '-'}
            </TableCell>
            <TableCell>
                {price || '-'}
            </TableCell>
            <TableCell>
                {cr || '-'}
            </TableCell>
            <TableCell>
                {funnels?.join(', ') || '-'}
            </TableCell>
            <TableCell>
                {sources?.join(', ') || '-'}
            </TableCell>
            <TableCell>
                {createdAt?.split('T')[0] || created || '-'}
            </TableCell>
        </tr>
    )
};